import React, { useCallback } from 'react'
import useReactRouter from 'use-react-router'
import usePluginRouter from 'core/hooks/usePluginRouter'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import { routes } from 'core/utils/routes'
import { deletePersistentVolume } from './new-actions'
import useUpdateAction from 'core/hooks/useUpdateAction'
import Modal from 'core/elements/modal'

export default function DeletePersistentVolumeDialog({ rows: [persistentVolume], onClose }) {
  const { currentPluginId } = usePluginRouter()
  const { history } = useReactRouter()
  const { update: deleteFn, updating: deletingPersistentVolume } = useUpdateAction(
    deletePersistentVolume,
  )
  const title = `Permanently delete "${persistentVolume?.name}"?`
  const handleDelete = useCallback(async () => {
    const routePath = currentPluginId === 'kubevirt' ? 'kubevirtStorage' : 'storage'
    await deleteFn(persistentVolume)
    onClose(true)
    history.push(routes[routePath].persistentVolumes.list.path())
  }, [persistentVolume, currentPluginId])

  return (
    <Modal
      panel="dialog"
      open
      onClose={onClose}
      title={title}
      maxWidth={600}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={deletingPersistentVolume}>
            Don't Delete
          </Button>
          <Button onClick={handleDelete} loading={deletingPersistentVolume}>
            Delete Persistent Volume
          </Button>
        </>
      }
    >
      <Text variant="body2">This action cannot be undone, are you sure you want to do this?</Text>
    </Modal>
  )
}
